// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_array = require("rescript/lib/js/caml_array.js");

function useClientSizeObserver(ref, onClientSizeChange) {
  React.useEffect((function () {
          var domElem = ref.current;
          if (domElem == null) {
            return ;
          }
          var observer = new ResizeObserver((function (mutations) {
                  if (mutations.length === 0) {
                    return ;
                  }
                  var target = Caml_array.get(mutations, mutations.length - 1 | 0).target;
                  var clientWidth = target.clientWidth;
                  var clientHeight = target.clientHeight;
                  Curry._2(onClientSizeChange, clientWidth, clientHeight);
                }));
          observer.observe(domElem);
          return (function (param) {
                    observer.disconnect();
                  });
        }), [ref.current]);
}

exports.useClientSizeObserver = useClientSizeObserver;
/* react Not a pure module */
